import { store as blockEditorStore } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import {
	// eslint-disable-next-line @wordpress/no-unsafe-wp-apis
	__experimentalInputControl as InputControl,
	MenuItem,
	Dropdown,
	Button,
	MenuGroup,
	// eslint-disable-next-line @wordpress/no-unsafe-wp-apis
	__experimentalVStack as VStack,
} from '@wordpress/components';
import { moreVertical } from '@wordpress/icons';
import { __ } from '@wordpress/i18n';

export const MergeFieldset = ( {
	fields,
	updateSettings,
	action,
	clientId,
} ) => {
	const updateMergeField = ( prop, val ) => {
		// 1. Make a shallow copy of the items
		const item = Object.assign( {}, action.merge_fields );
		// 2. Replace the property you're intested in
		item[ prop ] = val;
		// 3. Set the state to our new copy
		updateSettings( 'merge_fields', item );
	};

	return (
		<fieldset>
			<legend>{ __( 'Merge fields', 'popper' ) }</legend>
			<VStack spacing={ 4 }>
				{ fields?.map( ( field, i ) => {
					return (
						<MergeFields
							label={ field.label }
							value={ action.merge_fields?.[ field.name ] }
							clientId={ clientId }
							onChange={ ( val ) =>
								updateMergeField( field.name, val )
							}
							key={ i }
							help={ field.help }
						/>
					);
				} ) }
			</VStack>
		</fieldset>
	);
};

export const MergeFields = ( {
	label,
	value,
	onChange,
	placeholder,
	help,
} ) => {
	const fields = useSelect( ( select ) => {
		const ids =
			select( blockEditorStore ).getBlocksByName( 'popper/form-input' );
		const names = ids.map( ( id ) => {
			return select( blockEditorStore ).getBlock( id ).attributes.name;
		} );
		return names;
	} );

	return (
		<InputControl
			value={ value }
			label={ label }
			onChange={ onChange }
			placeholder={ placeholder }
			help={ help }
			suffix={
				<Dropdown
					popoverProps={ { placement: 'bottom-start' } }
					renderToggle={ ( { isOpen, onToggle } ) => (
						<Button
							onClick={ onToggle }
							aria-expanded={ isOpen }
							icon={ moreVertical }
							size="small"
						/>
					) }
					renderContent={ ( { onToggle } ) => (
						<MenuGroup>
							{ fields.map( ( field, i ) => {
								return (
									<MenuItem
										onClick={ () => {
											onChange( field );
											onToggle();
										} }
										key={ i }
									>
										{ field }
									</MenuItem>
								);
							} ) }
						</MenuGroup>
					) }
				/>
			}
			__next40pxDefaultSize
		/>
	);
};
